export function enableAutoTTS() {
    if (typeof window === 'undefined') {
        return;
    }
    var isiOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (!isiOS) {
        return;
    }
    var simulateSpeech = function () {
        var lecture = new SpeechSynthesisUtterance('hello');
        lecture.volume = 0;
        speechSynthesis.speak(lecture);
        document.removeEventListener('click', simulateSpeech);
    };
    document.addEventListener('click', simulateSpeech);
}
enableAutoTTS();
//# sourceMappingURL=index.js.map